module.exports = "https://static.wmbcdn.com/uniweb/images/1ae30ad5669d51b7977686d708b0fd0e.svg";